import Vue from 'vue'
//字符串截取过滤器
Vue.filter("filterText", function (text, len) {
    if (text && text.length > len && len && len > 0) {
        return text.substring(0, len) + "...";
    } else {
        return text;
    }
})


// 处理月份和日
Vue.filter("initMonth", function (val) {
    let newval = +val < 10 ? '0' + val : val;
    return newval;
});

// 周几数字转汉字
Vue.filter("isWeekWords", function (val) {
    switch (val) {
        case 0:
            return '周日';
        case 1:
            return '周一';
        case 2:
            return '周二';
        case 3:
            return '周三';
        case 4:
            return '周四';
        case 5:
            return '周五';
        case 6:
            return '周六';
        case '':
            return '';
    }
});

// 周几数字转汉字
Vue.filter("isWeekWords2", function (val) {
    switch (val) {
        case 0:
            return '日';
        case 1:
            return '一';
        case 2:
            return '二';
        case 3:
            return '三';
        case 4:
            return '四';
        case 5:
            return '五';
        case 6:
            return '六';
        case '':
            return '';
    }
});

// 时间戳转周几
Vue.filter("tranTimeToWeek", function (val) {
    if (val) {
        let day = new Date(val).getDay();
        return day;
    }
});

Vue.filter("isWeek", function (val) {
    if (val) {
        if (val.indexOf('T') != -1) {
            val = val.replace('T', ' ').replace(/-/g, '/');
        }
        let day = new Date(val).getDay();
        return day;
    }
});

// 处理x舱活动时间格式
Vue.filter('successTimeFormats', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate()
        let h = date.getHours()
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        val = M + '月' + D + '日' + ' ' + h + ':' + m;
    }
    return val;
})

// 处理x舱活动时间格式
Vue.filter('mm_dd_ch', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        val = M + '月' + D + '日';
    }
    return val;
})
// 处理x舱活动时间格式  val是时间戳
Vue.filter('mm_dd', function (val) {
    if (val) {
        var date = new Date(val);
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        val = M + '-' + D;
    }
    return val;
})
// val是带T的时间格式
Vue.filter('mm_dd_T', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        val = M + '-' + D;
    }
    return val;
})
// yyyy-mm-dd hh:mm
Vue.filter('yyyy_mm_dd_hh_mm', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        val = Y + '-' + M + '-' + D + ' ' + h + ':' + m;
    }
    return val;
})
// yyyy-mm-dd
Vue.filter('yyyy_mm_dd3', function (time) {
    if (!time) {
        return '请选择日期'
    }
    let date = '';
    let Y = new Date(time).getFullYear();
    let M = new Date(time).getMonth() + 1 >= 10 ? new Date(time).getMonth() + 1 : "0" + (new Date(time).getMonth() + 1);
    let D = new Date(time).getDate() >= 10 ? new Date(time).getDate() : "0" + new Date(time).getDate();
    date = Y + "-" + M + "-" + D;
    return date;
})
// yyyy-mm-dd
Vue.filter('yyyy_mm_dd_hh_mm2', function (val) {
    if (val) {
        var date = new Date(val);
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        val = Y + '-' + M + '-' + D + ' ' + h + ':' + m;
    }
    return val;
})

Vue.filter('yyyy_mm_dd', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        val = Y + '-' + M + '-' + D;
    }
    return val;
})
Vue.filter('yyyy_mm_dd2', function (val) {
    if (val) {
        var date = new Date(val);
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        val = Y + '-' + M + '-' + D;
    }
    return val;
})
Vue.filter('hh_mm', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        val = h + ':' + m;
    }
    return val;
})

// 处理x舱活动日期
Vue.filter('TimeFormats', function (val) {
    if (val && val !== 'nobuy') {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate();
        val = Y + '-' + M + '-' + D;
    } else {
        val = '敬请期待'
    }
    return val;
})

// 获得周几
Vue.filter('getWeek', function (val) {
    if (!val) {
        return val;
    }
    var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
    date = date.getDay()
    return date;
})

// 酒店是否可取消
Vue.filter('hotelCancel', function (val) {
    if (+val === 0) {
        val = '不可取消'
    } else if (+val === 1) {
        val = '可以取消'
    }
    return val;
})

Vue.filter('hotelStarType', function (val) {
    switch (+val) {
        case 0:
            return '豪华';
        case 1:
            return '五星';
        case 2:
            return '高档';
        case 3:
            return '四星';
        case 4:
            return '舒适';
        case 5:
            return '三星';
        case 6:
            return '经济型';
    }
})

// 酒店含不含早餐
Vue.filter('hotelFoodType', function (val) {
    switch (+val) {
        case 0:
            return '不含早';
        case 1:
            return '含早（免费）';
        case 2:
            return '含早（收费）';
    }
})

// 酒店窗户情况
Vue.filter('hotelWindowType', function (val) {
    switch (+val) {
        case 0:
            return '有窗';
        case 1:
            return '部分有窗';
        case 2:
            return '无窗';
    }
})

// 酒店是否可以上网
Vue.filter('hotelInternetType', function (val) {
    switch (+val) {
        case 0:
            return '无法上网';
        case 1:
            return '无线WIFI';
        case 2:
            return '有线宽带';
        case 3:
            return '无线WIFI和有线宽带';
    }
})

// 酒店床形
Vue.filter('hotelRoomType', function (val) {
    switch (+val) {
        case 0:
            return '大床';
        case 1:
            return '单间';
        case 2:
            return '双床';
        case 3:
            return '三人间';
        case 4:
            return '套房';
        case 5:
            return '独栋';
        case 6:
            return '床位房';
    }
})

// 含有几个早餐转成汉字
Vue.filter('hotelFoodNums', function (val) {
    switch (+val) {
        case 1:
            return '单';
        case 2:
            return '双';
        case 3:
            return '三';
        case 4:
            return '四';
        case 5:
            return '五';
        default:
            return ''
    }
})

// 行李订单是否支付a 

// 含有几个早餐转成汉字
Vue.filter('luggagePayStatus', function (val) {
    switch (+val) {
        case 1:
            return '未支付';
        case 2:
            return '已支付';
    }
})

// 1km以内显示km小于1km展示m
Vue.filter('formatRange', function (val) {
    if (val) {
        if (val > 1000) {
            val = parseFloat(val / 1000).toFixed(2) + 'km';
        } else {
            val = val + 'm'
        }
        return val
    } else {
        return ''
    }
})

// 行李订单状态
Vue.filter('luggageStatus', function (val) {
    if (!val) {
        return ''
    }
    switch (+val) {
        case 1:
            return '新订单';
        case 2:
            return '取消订单';
        case 3:
            return '订单完成';
        case 8:
            return '待执行';
        case 9:
            return '执行失败';
    }
})

// 如果改期时间为空，显示请选择日期，否则返回原来值
Vue.filter('flightChangeDate', function (val) {
    if (!val) {
        return '请选择日期'
    } else {
        return val;
    }
})

// 成人还是儿童
Vue.filter('selecttravellerType', function (val) {
    switch (+val) {
        case 1:
            return '成人';
        case 2:
            return '儿童';
    }
})
// 将日期专成年 + 月 + 日的形式
Vue.filter('formatYMD', function (val) {
    if (val) {
        if (val.toString().indexOf('T') > -1) {
            val = val.toString().replace('T', ' ').replace(/-/g, '/');
        }
        var date = new Date(val);
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        val = Y + '-' + M + '-' + D;
    }
    return val;
})
// 去掉日期里面的T hah
Vue.filter('clearTFormats', function (val) {
    if (val) {
        val = val.replace('T', ' ');
    }
    return val;
})
// 去掉日期里面的T hah
Vue.filter('clearTFormats2', function (val) {
    if (val) {
        val = val.replace('T', ' ');
        val = val.split(' ')[0];
    }
    return val;
})

// 去掉日期里面的T hah
Vue.filter('clearTFormats3', function (val) {
    if (val) {
        val = val.replace(/-/g, '/');
    }
    return val;
})

// 获取时间
Vue.filter('getTime', function (val) {
    if (val) {
        val = val.split(' ')[1];
    }
    return val;
})
// 计算两个时间差专成小时加分钟的形式
Vue.filter('spendTimes', function ([start, end]) {
    let val = ''
    if (start && end) {
        start = new Date(start.replace('T', ' ').replace(/-/g, '/'));
        end = new Date(end.replace('T', ' ').replace(/-/g, '/'));
        val = (end.getTime() - start.getTime()) / 1000;
        let h = parseInt(val / 3600);
        let m = parseInt((+val - h * 3600) / 60);
        if (h) {
            val = h + '时' + m + '分'
        } else {
            val = m + '分'
        }
    }
    return val;
})
// 转换时间差
Vue.filter('hasTimes', function (val) {
    if (val) {
        let h = parseInt(+val / 3600);
        let m = parseInt((+val - h * 3600) / 60);
        val = h + '时' + m + '分'
    }
    return val;
})
// 分钟转成小时 分钟  
Vue.filter('minuteInit', function (val) {
    if (val) {
        let h = parseInt(+val / 60);
        let m = parseInt(+val - h * 60);
        if (h==0) {
            val = m + '分'
        } else {
            val = h + '时' + m + '分'
        } 
    }
    return val;
})

// 舱位等级 
Vue.filter('canbinType', function (val) {
    switch (+val) {
        case 1:
            return '头等舱';
        case 2:
            return '商务舱';
        case 3:
            return '超级经济舱';
        case 4:
            return '经济舱';
    }
})
// 优惠券限制类别
Vue.filter('couponType', function (val) {
    switch (+val) {
        case 0:
            return '机票类';
        case 1:
            return '升舱类';
        case 2:
            return '行李类';
        case 3:
            return '餐食类';
    }
})
// 支付状态
Vue.filter('payStatus', function (val) {
    switch (+val) {
        case 1:
            return '待支付';
        case 2:
            return '取消订单';
        case 3:
            return '付款成功';
    }
})

// 支付状态
Vue.filter('payStatus2', function (val) {
    switch (+val) {
        case 1:
            return '待支付';
        case 2:
            return '取消订单';
        case 3:
            return '订单完成'
    }
})

// 退款状态
Vue.filter('refundStatus', function (val) {
    switch (+val) {
        case 1:
            return '未退款';
        case 2:
            return '退款成功';
    }
})

// 会员证件类型
Vue.filter('foidType2', function (val) {
    switch (val) {
        case 1:
            return '身份证';
        case 2:
            return '护照';
        case '':
            return '请选择';
    }
})

// 性别
Vue.filter('sexType', function (val) {
    switch (+val) {
        case 1:
            return '男';
        case 2:
            return '女';

    }
})

// 是不是认证会员
Vue.filter('anthVip', function (val) {
    if (val) {
        return ''
    } else {

    }
})


// 标题
Vue.filter("swiperTit", function (val) {
    switch (+val) {
        case 1:
            return '商城';
        case 3:
            return '电影';
        case 4:
            return '短视频';
        case '':
            return '';
    }
})
// 休息室状态
Vue.filter('restOrderStatus', function (val) {
    switch (val) {
        case 1:
            return "待支付";
        case 2:
            return "已支付";
        case 3:
            return "已退款";
        case 4:
            return "退款中";
        case 5:
            return "待使用";
        case 6:
            return "已使用";
        case 7:
            return "已取消";
        case 8:
            return "已过期";
    }
})
// 龙腾权益类型
Vue.filter('dragonpassServiceType', function (val) {
    switch (val) {
        case 1:
            return "休息室";
        case 2:
            return "美食";
        case 3:
            return "接送机";
        case 4:
            return "安检";
    }
})
// 证件类型
Vue.filter('selectfoidType', function (val) {
    switch (+val) {
        case 1:
            return "身份证";
        case 2:
            return "护照";
        case 3:
            return "台胞证";
        case 4:
            return "港澳通行证";
        case 6:
            return "外国人永久居留身份证";
        case 11:
            return "港澳台居民居住证";
        case 21:
            return "户口簿";
        case 22:
            return "回乡证";
        case 25:
            return "海员证";
        case 32:
            return "外国人出入境证"; 
        case 100:
            return "其他";
    }
})

// 订单状态
Vue.filter('orderTypes', function (val) {
    switch (+val) {
        case 1:
            return '普通';
        case 2:
            return '改期';
    }
})

// 是不是受让人  
Vue.filter('isGralEnriched', function (val) {
    switch (+val) {
        case 0:
            return '';
        case 1:
            return '受让人';
        case 2:
            return '';
        case 3:
            return '本人'
    }
})

// 
Vue.filter('isAbleStatus', function (val) {
    switch (+val) {
        case 1:
            return '待生效';
        case 2:
            return '';
    }
})

// 手机号中间四位变星星
Vue.filter('phoneXin', function (val) {
    if (val && val.length == 11) {
        var reg = /^(\d{3})\d*(\d{4})$/;
        var str2 = val.replace(reg, '$1****$2');
        return str2;
    } else {
        return val;
    }
})



// 处理特殊旅客轮椅类型
Vue.filter('wheeChairType', function (arr) {
    let str = '';
    if (arr && arr.length) {
        str = arr.join(',');
    }
    return str;
})

// 特殊旅客审核结果状态
Vue.filter('spResultStatus', function (val) {
    switch (+val) {
        case 1:
            return '恭喜您，已通过申请';
        case 2:
            return '很遗憾，申请未通过';
        case 3:
            return '审核中，请等待';
        case 4:
            return '已取消申请';
    }
})


// 特殊旅客审核结果状态
Vue.filter('spResultStatus2', function (val) {
    switch (+val) {
        case 1:
            return '已通过申请';
        case 2:
            return '申请未通过';
        case 3:
            return '审核中';
        case 4:
            return '已取消申请';
    }
})

// 特殊旅客审核结果状态
Vue.filter('spApplyType', function (val) {
    switch (+val) {
        case 1:
            return '轮椅旅客';
        case 3:
            return '孕妇旅客';
        case 4:
            return '病患旅客';
        case 6:
            return '视力听力障碍旅客';
    }
})

// 特殊旅客服务类型
Vue.filter('spType', function (val) {
    switch (+val) {
        case 1:
            return '轮椅旅客服务办理须知';
        case 3:
            return '孕妇旅客服务办理须知';
        case 4:
            return '病患旅客服务办理须知';
        case 6:
            return '视力听力障碍旅客服务办理须知';
    }
})

// 将日期专成年 + 月 + 日+HH+mm+ss的形式
Vue.filter('formatYMDHMS', function (val) {
    if (val) {
        if (val.toString().indexOf('T') > -1) {
            val = val.toString().replace('T', ' ').replace(/-/g, '/');
        }
        var date = new Date(val);
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        let H = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        val = Y + '-' + M + '-' + D + ' ' + H + ':' + m + ':' + s;
    }
    return val;
})

Vue.filter('formatYMD2', function (val) {
    if (val) {
        if (val.toString().indexOf('T') > -1) {
            val = val.toString().replace('T', ' ').replace(/-/g, '/');
        }
        var date = new Date(val);
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        let H = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        val = Y + '.' + M + '.' + D;
    }
    return val;
})
// 优惠券叠加  
Vue.filter('compositAbled', function (val) {
    switch (+val) {
        case 0:
            return '不可叠加使用';
        case 1:
            return '可与直减券叠加使用';
        case 2:
            return '可与满减券、直减券叠加使用';
    }
})
//机票订单列表状态
Vue.filter('tktOrderStatus', function (val) {
    switch (+val) {
        case 1:
            return '新订单';
        case 3:
            return '交易完成';
        //不走退款流程的单子（例如升舱）
        case 7:
            return '已退款';
        case 8:
            return '交易完成';
        case 9:
            return '出票失败';
        case 10:
            return '升舱已改期';
        default:
            return '交易关闭';
    }
})
// 龙腾休息室权益状态
Vue.filter('rightStatus', function (status) {
    switch (+status) {
        case 0:
            return "待生效";
        case 1:
            return "未使用";
        case 2:
            return "已使用";
        case 3:
            return "已退款";
        case 4:
            return "退款失败";
        case 5:
            return "部分退款";
    }
})

// 升舱类型
Vue.filter('upgradeType', function (val) {
    let text = '';
    switch (val) {
        case 1:
            text = '值机柜台升舱';
            break;
        case 2:
            text = '登机口升舱';
            break;
        case 3:
            text = '机上升舱';
            break;
        default:
            break;
    }
    return text;
})

// 升舱类型
Vue.filter('cabinSeg', function (val) {
    let text = ''
    switch (val) {
        case 0:
            text = '一';
            break;
        case 1:
            text = '二';
            break;
        default:
            break;
    }
    return text;
})

// 机+x产品标题
Vue.filter('productTip', function (val) {
    let text = ''
    switch (val) {
        case 'HT':
            text = '机票+酒店';
            break;
        case 'CS':
            text = '美食飞行家';
            break;
        case 'DZ':
            text = '一人两座 舒适飞行';
            break;
        case 'XZ':
            text = '赠前排座位';
            break;
        case 'VL':
            text = '贵宾休息室';
            break;
        case 'R1YY':
            text = '迎亚运，享升舱，送好礼';
            break;
        default:
            break;
    }
    return text;
})

// 机+x产品内容
Vue.filter('productTntroduce', function (val, name) {
    let text = '';
    switch (val) {
        case 'HT':
            text = '含国内知名连锁酒店，入住更省心';
            break;
        case 'CS':
            text = '今日特供美食，' + name;
            break;
        case 'DZ':
            text = '可享两个座位，加大座位空间';
            break;
        case 'XZ':
            text = '前排优先选座';
            break;
        case 'VL':
            text = '舒适候机不拥挤';
            break;
        default:
            break;
    }
    return text;
})

// 年月日时分秒
Vue.filter('yyyymmddhhff', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let Y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate()
        let h = date.getHours()
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        // let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        val = Y + '年' + M + '月' + D + '日' + ' ' + h + '时' + m + '分';
    }
    return val;
})

// 两端日期差几天
Vue.filter('getDayDiff', function (depart, arrive) {
    let val = '';
    if (depart && arrive) {
        let last = new Date(
            arrive.slice(0, arrive.indexOf("T")).replace(/-/g, "/")
        ).getTime();
        let first = new Date(
            depart.slice(0, depart.indexOf("T")).replace(/-/g, "/")
        ).getTime();
        let oneDay = 24 * 3600 * 1000;
        val = (last - first) / oneDay;
        if (val) {
            return '+' + val;
        } else {
            return ''
        } 
    }
    return val;
})

// 月日时分秒
Vue.filter('mm_dd_hh_mm', function (val) {
    if (val) {
        var date = new Date(val.replace('T', ' ').replace(/-/g, '/'));
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        val = M+'月'+D+'日'+h + ':' + m;
    }
    return val;
})
// 行李服务订单类型
Vue.filter('treatmentStatus', function (val) {
    let text = '';
    switch (val) {
        case 0:
            text = '待处理';
            break;
        case 1:
            text = '处理中';
            break;
        case 2:
            text = '已处理';
            break;
        default:
            break;
    }
    return text;
})
// 行李服务申请类型  
Vue.filter('abnormalLuggageType', function (val) {
    let text = '';
    switch (val) {
        case 1:
            text = '行李遗失';
            break;
        case 2:
            text = '行李破损';
            break;
        default:
            break;
    }
    return text;
})

// 是否托运行李遗失  
Vue.filter('ifCheckedLuggage', function (val) {
    let text = '';
    switch (val) {
        case 0:
            text = '否';
            break;
        case 1:
            text = '是';
            break;
        default:
            break;
    }
    return text;
})

Vue.filter('goodType', function (val){
    switch (val) {
        case 1:
        return '手机电脑Ipad';
        break;
        case 2:
        return '现金证券类';
        break;
        case 3:
        return '手表首饰皮夹';
        break;
        case 4:
        return '证件类物品';
        break;
        case 5:
        return '电子数码配件';
        break;
        case 6:
        return '充电宝锂电池';
        break;
        case 7:
        return '服饰箱包类';
        break;
        case 8:
        return '普通生活物品';
        break;
        case 9:
        return '鲜活易腐蚀类';
        break;
        case 10:
        return '易燃有气味类';
        break;
        case 11:
        return '武器类物品';
        break;
        case 12:
        return '文物类物品';
        break;
        case 13:
        return '照片类物品';
        break;
        case 14:
        return '其他';
        break;
        case 51:
        return  '拉杆箱';
        break;
        case 52:
        return  '手推车';
        break;
        case 53:
        return  '纸箱';
        break;
        case 54:
        return  '三脚架';
        break;
        case 55:
        return  '手提包';
        break;
        case 56:
        return  '背包';
        break;
        case 57:
        return  '其他';
        break;
    }
})
Vue.filter('positionType', function (val){
    switch(val){
        case 1:
        return  '前面座椅口袋';
        break;
        case 2:
        return  '上方行李架';
        break;
        case 3:
        return  '座位上';
        break;
        case 4:
        return  '洗手间';
        break;
        case 5:
        return  '地面上';
        break;
        case 6:
        return  '不确定';
        break; 
    }
})

// 电子发票客票状态
Vue.filter('inoviceStatus', function (val){
    let text = '';
    switch (val) {
        case 1:
            text = '机场控制';
            break;
        case 2:
            text = '未使用';
            break;
        case 3:
            text = '正在办理登机手续';
            break;
        case 4:
            text = '打印过行程单';
            break;
        case 5:
            text = 'oi换开';
            break;
        case 6:
            text = '已退票';
            break;
        case 7:
            text = '电客已使用';
            break;
        case 8:
            text = '挂起状态';
            break;
        case 9:
            text = 'Unavailable';
            break;
        case 10:
            text = '航班迁转';
            break;
        case 11:
            text = 'IrregularOperations';
            break;
        case 12:
            text = '票号已作废';
            break;
        case 13:
            text = 'pet换开';
            break;
        case 14:
            text = 'Unknow';
            break;
        case 15:
            text = 'NotExit';
            break;
        case 16:
            text = '已经办理登机手续';
            break;
        case 17:
            text = 'Format';
            break;
        case 18:
            text = 'Error';
            break;
        default:
            break;
    }
    return text;
})

// 电子发票状态
Vue.filter('inoviceDetailStatus', function (val){
    let text = '';
    switch (val) {
        case 1:
            text = '已发送';
            break;
        case 2:
            text = '申请中';
            break;
        case 3:
            text = '终止';
            break;
        default:
            break;
    }
    return text;
})



// WEBPACK FOOTER //
// ./src/filters/filter.js